import { calculateGrossUpAmount } from './stripeFee';

export const draftLineItemId = () =>
	`draft-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

export const toNumber = (value, fallback = 0) => {
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : fallback;
};

export const lineItemTotal = (item) =>
	toNumber(item.quantity, 0) * toNumber(item.unit_price, 0);

export const rowSnapshot = (row) =>
	JSON.stringify({
		description: (row.description || '').trim(),
		quantity: toNumber(row.quantity, 1),
		unit_price: toNumber(row.unit_price, 0).toFixed(2),
	});

export const isDraftLineItem = (row) =>
	!row.id || String(row.id).startsWith('draft-');

export const isLineItemComplete = (row) => {
	const quantity = toNumber(row.quantity, 0);
	const unitPrice = toNumber(row.unit_price, 0);
	return quantity > 0 && unitPrice > 0;
};

export const completeLineItems = (rows) =>
	(rows || []).filter((row) => isLineItemComplete(row));

export const lineItemsGrandTotal = (rows) =>
	(rows || []).reduce((sum, row) => sum + lineItemTotal(row), 0);

export const quotedLineItemsTotal = (rows, includesStripeFee = false) => {
	const net = lineItemsGrandTotal(completeLineItems(rows));
	if (!includesStripeFee || net <= 0) {
		return net;
	}
	return calculateGrossUpAmount(net);
};

export const formatLineItemCurrency = (value) =>
	Number(value || 0).toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
	});

export const createDraftLineItem = () => {
	const key = draftLineItemId();
	return {
		_key: key,
		id: key,
		description: '',
		quantity: 1,
		unit_price: '',
	};
};

export const serializeLineItemsForApi = (rows) =>
	completeLineItems(rows).map((row) => ({
		description: (row.description || '').trim(),
		quantity: Math.round(toNumber(row.quantity, 1)),
		unit_price: toNumber(row.unit_price, 0).toFixed(2),
	}));

export const itemizedBidAmountMatches = (
	lineItemsTotal,
	bidAmount,
	quoteIncludesStripeFee = false,
) => {
	const net = Number(lineItemsTotal) || 0;
	const bid = Number(bidAmount) || 0;
	if (net <= 0 && bid <= 0) {
		return true;
	}
	const expected = quoteIncludesStripeFee ? calculateGrossUpAmount(net) : net;
	return Math.abs(expected - bid) <= 0.01;
};

export const resolveItemizedFromJob = (
	selectedJob,
	{ defaultItemizedBids = false } = {},
) => {
	if (selectedJob?.bid_details?.itemized_pricing) {
		return true;
	}
	const lineItems = selectedJob?.bid_details?.line_items || [];
	if (lineItems.length > 0) {
		return true;
	}
	const lineItemsTotal = Number(selectedJob?.line_items_total) || 0;
	if (lineItemsTotal > 0) {
		return true;
	}
	return defaultItemizedBids;
};

export const resolveChangeOrderItemized = (selectedJob) => {
	if (selectedJob?.bid_details?.itemized_pricing) {
		return true;
	}
	const lineItems = selectedJob?.bid_details?.line_items || [];
	if (lineItems.length > 0) {
		return true;
	}
	return Number(selectedJob?.line_items_total) > 0;
};
